import { render, staticRenderFns } from "./BaseNavigationStamm.vue?vue&type=template&id=cccae0e0&scoped=true"
import script from "./BaseNavigationStamm.vue?vue&type=script&lang=ts"
export * from "./BaseNavigationStamm.vue?vue&type=script&lang=ts"
import style0 from "./BaseNavigationStamm.vue?vue&type=style&index=0&id=cccae0e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cccae0e0",
  null
  
)

export default component.exports